import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties from '../../models/INFTProperties'
import { IAvaxtarsCard } from '../../nftFormats/Avaxtars/Card/IAvaxtarsCard'
import BaseDetail from './BaseDetail'


export default function AvaxtarsDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IAvaxtarsCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTDescription() {
    return (
      <div>
        What is AVAXTARS?
        <p>
          AVAXTARS is an NFT based browser game build on the Avalanche Blockchain Platform and has its own tokenomics
          based on $AVXT Tokens.
          <br />
          Players need to create at least one AVAXTAR to play this game.
        </p>
        Who are AVAXTARS?
        <p>
          Every Avaxtar is a digitally generated avatar. Images of Avaxtars are saved on IPFS and their existence is
          recorded on Avalanche Mainnet as unique ERC-721 Tokens. To create an Avaxtar we are using a Digital Genetic
          Code (DGC) and we create a hash value of these genes, so we guarantee that all of the Avaxtars are different
          than each other.
        </p>
      </div>
    )
  }

  function getNFTProperties() {
    const result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.rarity) {
      result.push({
        key: 'Rarity',
        value: detailTokenItem.rarity,
        show: true,
        isUrl: false
      })
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={getNFTDescription()}
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={getNFTProperties()}
      externalUrl={detailTokenItem ? detailTokenItem.external_url : ''}
    >
      {detailTokenItem ? <img src={detailTokenItem.ipfs_image} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
